<p-toast></p-toast>

<div class="fluid formgrid grid p-2 md:p-4">
    <div class="col-12">
        <p-card>
            <h6 class="mb-3">Informations de la clé</h6>
            <div class="fluid formgrid grid">
                <div class="flex flex-column gap-2 my-2 col-12">
                    <label for="nom" class="font-semibold">Nom / Application *</label>
                    <input id="nom" type="text" pInputText [(ngModel)]="cle.nom"
                        class="w-full" placeholder="Ex: Portail Client, Mobile App..."
                        [class.ng-invalid]="submitted && !cle.nom" />
                    <small *ngIf="submitted && !cle.nom" class="p-error">Le nom est obligatoire.</small>
                </div>

                <div class="flex flex-column gap-2 my-2 col-12">
                    <label for="expiration" class="font-semibold">Date d'expiration (optionnel)</label>
                    <p-calendar id="expiration" [(ngModel)]="cle.dateExpiration" 
                        [showIcon]="true" dateFormat="yy-mm-dd" [minDate]="today"
                        appendTo="body" placeholder="Sélectionnez une date"
                        [touchUI]="isMobile"></p-calendar>
                    <small class="text-color-secondary">Laissez vide pour une clé sans expiration.</small>
                </div>
            </div>
        </p-card>
    </div>

    <!-- Section Permissions (Placeholder) -->
    <div class="col-12 mt-3">
        <p-card>
            <h6 class="mb-3"><i class="pi pi-lock mr-2"></i>Permissions</h6>
            <div class="p-3 surface-100 border-round text-center">
                <i class="pi pi-info-circle text-2xl mb-2 text-primary"></i>
                <p>La gestion granulaire des permissions sera disponible dans une version ultérieure.</p>
                <p class="text-sm text-color-secondary">Pour l'instant, toutes les clés ont un accès standard.</p>
            </div>
        </p-card>
    </div>

    <div class="col-12 flex flex-column sm:flex-row justify-content-end gap-2 pt-4">
        <p-button label="Annuler" icon="pi pi-times" styleClass="p-button-secondary p-button-text w-full sm:w-auto" 
            (onClick)="annuler()" [disabled]="chargementEnCours"></p-button>
        <p-button [label]="modeEdition ? 'Enregistrer' : 'Générer la clé'" 
            [icon]="modeEdition ? 'pi pi-check' : 'pi pi-key'" 
            styleClass="w-full sm:w-auto"
            [loading]="chargementEnCours" (onClick)="sauvegarder()"></p-button>
    </div>
</div>

<!-- Dialogue pour afficher la clé générée (SEULE FOIS) -->
<p-dialog header="Clé API générée avec succès" [(visible)]="afficherCleGeneree" 
    [modal]="true" [closable]="false" [style]="{width: '95vw', 'max-width': '450px'}" 
    [breakpoints]="{'960px': '90vw', '640px': '95vw'}" appendTo="body">
    <div class="flex flex-column align-items-center gap-3 py-3">
        <i class="pi pi-exclamation-triangle text-orange-500 text-5xl"></i>
        <p class="text-center font-bold">ATTENTION : Cette clé ne sera affichée qu'une seule fois.</p>
        <p class="text-center">Veuillez la copier et la conserver en lieu sûr. Vous ne pourrez plus la consulter par la suite.</p>
        
        <p-inputGroup class="w-full mt-2">
            <input type="text" pInputText [value]="cleGeneree" readonly 
                class="font-monospace text-sm md:text-base p-2 md:p-3 surface-100" 
                style="word-break: break-all;" />
            <button type="button" pButton icon="pi pi-copy" pTooltip="Copier la clé" (click)="copierCle()"></button>
        </p-inputGroup>
    </div>
    <div class="flex flex-column align-items-center gap-3 py-3">
        <p-inputGroup class="w-full mt-2">
            <input type="text" pInputText [value]="cle.clientId" readonly 
                class="font-monospace text-sm md:text-base p-2 md:p-3 surface-100" 
                style="word-break: break-all;" />
            <button type="button" pButton icon="pi pi-copy" pTooltip="Copier le Client ID" (click)="copierClientId()"></button>
        </p-inputGroup>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-center">
            <p-button label="J'ai bien noté la clé" icon="pi pi-check" (onClick)="fermerApresCreation()"></p-button>
        </div>
    </ng-template>
</p-dialog>

